import React from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useFormContext } from "react-hook-form";
import '../../../assets/terms/credit-protection.css';
import marketing from "../../../services/marketing";
import PixelsService from '../../../services/pixels';
import { FLOW } from '../../../models/websiteTypesConstants';

function CreditProtection() {

    const { register,  formState: { errors } } = useFormContext();    
    const brandSettings = useStoreState((state) => state.siteSettingsModel.brandSettings);
    const setting = useStoreState((state) => state.siteSettingsModel);
    const cpLink = useStoreState(state => state.siteSettingsModel.productSettings);
    const assetsBaseUrl = useStoreState(state => state.siteSettingsModel.webAssetsBaseUrlSettings);
    const utm = new marketing();
    const applicationResult = useStoreState(state => state.applicationResultModel.applicationResult);
    const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
    const info = useStoreState((state) => state.applicantModel.applicant);
    const WaterfallValues = {"CFC" : 14, "STANDALONE" : 20  }
    const utms = new marketing();
    const PixelService = new PixelsService();
 
    const monthlyCharge = setting.mainSettings.Flow === FLOW.DM ? info.CreditProtectionPrice : 1.39; 

    return (
        <div className="col-lg-12">
            
            <div className="container-fluid">
                <div className='row'>
                </div>
                <div className="row credit-protection">
                   
                    <div className="col-lg-12 credit-protection-content">
                    <h6>Credit Protection is an optional program that offers benefits for unforeseen events such as involuntary termination from employment, disability, hospitalization, FMLA, natural disaster and loss of life.</h6>

                    {errors.creditProtection ? 
                            <div className="error-message mt-1"> You must choose an option before continue. </div>
                            :
                            <></>
                        }                        
                        <div className="form-check check-fields mt-0">
                            <input
                            onClick={(e) => {
                                setInfo({ index: "creditProtection", value: e.target.value, });utm.updateSessionReport("continentalCreditProtection");
                                PixelService.event("google", setting.mainSettings.Flow, "Credit Protection")
                                if(setting.mainSettings.Flow === FLOW.CFC || setting.mainSettings.Flow === FLOW.STANDALONE){ 
                                    utms.trackEvent(
                                        WaterfallValues[setting.mainSettings.Flow], 
                                        setting.mainSettings.Flow, 
                                        applicationResult.ref_number ?? "",
                                        setting.productSettings.ProductId, 
                                        "Flow");}
                                }
                            }
                             name="creditProtection" className="form-check-input" type="checkbox" value="yes" id="credit-protection-yes"  checked={(info.creditProtection === "yes" ? true : false)} {...register("creditProtection")} />
                            <label className="form-check-label" htmlFor="">
                                <b>Yes</b>, I want to purchase the optional Continental Credit Protection Program (the “Program”).
                            </label>
                        </div>
                        <div className='mt-2'><h6>By choosing to purchase this optional Program, I understand that:</h6></div>
                        <ul>
                            <li>My decision to purchase or not purchase the Program will not affect my application for credit or the terms of any existing account I have with {brandSettings.BankName}.</li>
                            <li>The monthly charge for the Program is ${monthlyCharge} for every $100 of my outstanding Account balance as of the close of each Billing Cycle.</li>
                            <li>
                                I have read the Program terms, conditions, exclusions, and requirements as outlined in the <a onClick={() => { utm.updateSessionReport("creditProtectionLink") }} href={cpLink.OnlineCreditProtectionUrl} target="_blank" rel="noopener noreferrer" ><u>Continental Credit Protection Addendum</u></a> (the “Addendum”), which may limit or prevent me from receiving Program Benefits.
                            </li>
                            <li>While receiving Program Benefits, I will not be able to make new purchases or obtain cash advances using my credit card.</li>
                            <li>I can cancel this Program at any time. If I cancel within 30 days of purchase, I will receive a full refund of any charges.</li>
                        </ul>
                        <div className="form-check check-fields">
                            
                            <input name='creditProtection' className="form-check-input" type="checkbox" value="no" id="credit-protection-no" checked={(info.creditProtection === "no" ? true : false)} onClick={(e) => { setInfo({ index: "creditProtection", value: e.target.value, });  }} {...register("creditProtection")} />
                            <label className="form-check-label" htmlFor="credit-protection-no" >
                            <b>NO</b>, I am not interested in the Continental Credit Protection Program.
                        </label>
                        </div>
                        
                    </div>
                </div>
            </div>

        </div>
    )

}

export default CreditProtection